import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

export default function Disclaimer() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main className="pt-20 pb-20 px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mx-auto">
          <h1 className="font-heading text-3xl sm:text-4xl font-bold mb-6 text-primary-500">Disclaimer</h1>
          <div className="space-y-4 text-foreground-700 font-body leading-relaxed">
            <p>
              The information provided on ClearMind Club is for educational and informational purposes only. It is not intended to be a substitute for professional medical advice, diagnosis, or treatment.
            </p>
            <p>
              Always seek the advice of your physician or other qualified health provider with any questions you may have regarding a medical condition or before beginning any supplement, exercise, or wellness program.
            </p>
            <p>
              Never disregard professional medical advice or delay in seeking it because of something you have read on this website.
            </p>
            <p>
              The nootropic reviews and recommendations on this site are based on publicly available research and user experiences. Individual results may vary, and what works for one person may not work for another.
            </p>
            <p>
              If you think you may have a medical emergency, call your doctor or emergency services immediately.
            </p>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}